// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"26":"3ef40cce","513":"18e58e49"}[chunkId] + ".js";
};